export class CountrySettings {
  company_name: string;
  automatic_updates: boolean;
  office_hours: string;
  address: string;
  contact: string;
}
